import { styled } from "@mui/joy";

type Props = {
  error?: boolean;
  children: React.ReactNode;
};

const FormGroupRoot = styled("div", {
  name: "FormGroup",
  slot: "Root",
})<{ ownerState: { error?: boolean } }>(({ ownerState }) => ({
  ...(ownerState.error && {
    ".MuiInput-root": {
      borderColor: "var(--joy-palette-danger-outlinedBorder)",
    },
    ".MuiInput-root input": {
      color: "var(--joy-palette-danger-outlinedColor)",
    },
  }),
  ".MuiFormLabel-root": {
    marginBottom: "0.375rem",
  },
  ".MuiFormHelperText-root": {
    marginTop: "0.375rem",
    ...(ownerState.error && {
      color: "var(--joy-palette-danger-outlinedColor)",
    }),
  },
}));

export default function FormGroup({ children, ...props }: Props) {
  return <FormGroupRoot ownerState={props}>{children}</FormGroupRoot>;
}
